import { render } from "./addpurchaseorder.vue?vue&type=template&id=184e89ac&scoped=true"
import script from "./addpurchaseorder.vue?vue&type=script&lang=js"
export * from "./addpurchaseorder.vue?vue&type=script&lang=js"

import "./addpurchaseorder.vue?vue&type=style&index=0&id=184e89ac&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184e89ac"]])

export default __exports__